export default __webpack_public_path__ + "static/media/handy-qr-template.d373eb85.pdf";